<template>
  <div id="app">
    <router-view v-if="showRouter" />
  </div>
</template>

<script>
// import { getAndSetTokenInfo } from './tokenLogin.js'
import { getQueryStrings } from './util'
export default {
  name: 'App',
  data() {
    return { showRouter: false }
  },
  async created() {
    sessionStorage.getItem('source_channel') && sessionStorage.removeItem('source_channel')
    const sourceChannel = getQueryStrings('source_channel')
    if (sourceChannel.source_channel) {
      sessionStorage.setItem('source_channel', sourceChannel.source_channel)
    }
    // await getAndSetTokenInfo()
    this.showRouter = true
  },
}
</script>

<style>
#app {
  height: 100%;
}
#wrapper {
  height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
#qiankun_wrapper {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
</style>
